<template>
    <div>
        <LiefengContent>
            <template v-slot:title>员工管理</template>
            <template v-slot:toolsbarRight>
                <Form :label-colon="true" :inline="true" class="search">
                    <FormItem>
                        <Input v-model.trim="searchData.idOrName" style="width: 180px" placeholder="姓名/手机/工号" clearable></Input>
                    </FormItem>
                    <FormItem>
                        <Select v-model="searchData.orgWorkStatus" transfer style="width: 120px" placeholder="在职状态" clearable>
                            <Option value="1">在职</Option>
                            <Option value="2">离职</Option>
                        </Select>
                    </FormItem>
                    <Button type="primary" icon="ios-search" style="margin-right: 10px" @click="handleSearch">查询</Button>
                    <Button type="success" icon="ios-refresh" style="margin-right: 10px" @click="resetBtn">重置</Button>
                    <Button type="primary" icon="ios-add" @click="handleAdd">新增</Button>
                </Form>
            </template>
            <template v-slot:contentArea>
                <LiefengTable
                    :talbeColumns="talbeColumns"
                    :tableData="tableData"
                    :loading="loading"
                    :fixTable="true"
                    :curPage="page"
                    :total="total"
                    :pagesizeOpts="[20, 30, 50, 100]"
                    :page-size="pageSize"
                    @hadlePageSize="hadlePageSize"
                ></LiefengTable>
            </template>
        </LiefengContent>

        <LiefengModal
            :title="editType === 'add' ? '新增员工' : '修改员工'"
            :value="editStatus"
            @input="changeEditStatus"
            width="560px"
            height="520px"
        >
            <template v-slot:contentarea>
                <EditForm v-if="editStatus" :formData="formData" :editType="editType" :orgCode="orgCode"></EditForm>
            </template>
            <template v-slot:toolsbar>
                <Button type="primary" style="margin-right: 10px" @click="saveEdit">保存</Button>
                <Button type="info" @click="changeEditStatus(false)">取消</Button>
            </template>
        </LiefengModal>
    </div>
</template>

<script>
import LiefengContent from "@/components/LiefengContent3"
import LiefengTable from "@/components/LiefengTable"
import LiefengModal from "@/components/LiefengModal"
import EditForm from "./childrens/editform"

export default {
    components: { LiefengContent, LiefengTable, LiefengModal, EditForm },
    data() {
        return {
            searchData: {
                idOrName: "",
                orgWorkStatus: "",
            },
            tableData: [],
            loading: false,
            page: 1,
            pageSize: 20,
            total: 0,
            editType: "add",
            editStatus: false,
            formData: {},
            orgCode: "",
            staffId: "",
            oemCode: "",
            userType: "09",
            talbeColumns: [
                {
                    title: "姓名",
                    minWidth: 120,
                    align: "center",
                    key: "name",
                },
                {
                    title: "手机号",
                    minWidth: 130,
                    align: "center",
                    key: "phone",
                },
                {
                    title: "所属机构",
                    minWidth: 180,
                    align: "center",
                    key: "orgName",
                },
                {
                    title: "在职状态",
                    minWidth: 100,
                    align: "center",
                    key: "orgWorkStatus",
                    render: (h, params) => {
                        const statusMap = { 1: "在职", 2: "离职" }
                        const status = params.row.orgWorkStatus
                        return h("span", statusMap[status] || "-")
                    },
                },
                {
                    title: "角色",
                    minWidth: 160,
                    align: "center",
                    key: "roleNames",
                },
                {
                    title: "登录账号",
                    minWidth: 130,
                    align: "center",
                    key: "account",
                },
                {
                    title: "操作",
                    align: "center",
                    fixed: "right",
                    width: 280,
                    render: (h, params) => {
                        const row = params.row
                        const workStatus = String(row.orgWorkStatus || "")
                        const workBtnLabel = workStatus === "1" ? "离职" : "在职"
                        const workBtnStatus = workStatus === "1" ? "2" : "1"
                        return h("div", { style: { textAlign: "center" } }, [
                            h(
                                "span",
                                {
                                    style: this.actionStyle,
                                    on: {
                                        click: () => {
                                            this.handleEdit(row)
                                        },
                                    },
                                },
                                "修改"
                            ),
                            h(
                                "span",
                                {
                                    style: this.actionStyle,
                                    on: {
                                        click: () => {
                                            this.changeWorkStatus(row, workBtnStatus)
                                        },
                                    },
                                },
                                workBtnLabel
                            ),
                            h(
                                "span",
                                {
                                    style: this.actionStyle,
                                    on: {
                                        click: () => {
                                            this.openAuthModal(row)
                                        },
                                    },
                                },
                                "设置权限"
                            ),
                            h(
                                "span",
                                {
                                    style: {
                                        ...this.actionStyle,
                                        marginRight: "0",
                                        color: "#ed4014",
                                    },
                                    on: {
                                        click: () => {
                                            this.handleDelete(row)
                                        },
                                    },
                                },
                                "删除"
                            ),
                        ])
                    },
                },
            ],
            actionStyle: {
                marginRight: "10px",
                color: "#2d8cf0",
                cursor: "pointer",
                userSelect: "none",
            },
        }
    },
    created() {
        this.initContext()
        this.getList()
    },
    methods: {
        initContext() {
            this.staffId = parent.vue.loginInfo.userinfo.id
            this.oemCode = parent.vue.oemInfo.oemCode
            this.orgCode = window.sessionStorage.getItem("orgCode") || parent.vue.loginInfo.userinfo.orgCode || ""
        },
        getList() {
            this.loading = true
            const params = {
                userType: this.userType,
                oemCode: this.oemCode,
                staffId: this.staffId,
                orgCode: this.orgCode,
                page: this.page,
                pageSize: this.pageSize,
            }
            if (this.searchData.idOrName) {
                params.idOrName = this.searchData.idOrName
            }
            if (this.searchData.orgWorkStatus) {
                params.orgWorkStatus = this.searchData.orgWorkStatus
            }
            this.$get("/old/api/pc/staff/selectManagerStaffPageV2", params)
                .then(res => {
                    this.loading = false
                    if (res.code == 200 || res.code == "200") {
                        this.tableData = res.dataList || []
                        this.total = res.maxCount || 0
                    } else {
                        this.$Message.error({
                            content: res.desc || "数据获取失败",
                            background: true,
                        })
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },
        handleSearch() {
            this.page = 1
            this.getList()
        },
        resetBtn() {
            this.searchData = {
                idOrName: "",
                orgWorkStatus: "",
            }
            this.page = 1
            this.pageSize = 20
            this.getList()
        },
        hadlePageSize(page, pageSize) {
            this.page = page
            this.pageSize = pageSize
            this.getList()
        },
        changeEditStatus(val) {
            this.editStatus = val
            if (!val) {
                this.formData = {}
            }
        },
        handleAdd() {
            this.editType = "add"
            this.formData = {
                userName: "",
                phone: "",
                avatarUrl: "",
                national: "",
                nativePlace: "",
                address: "",
                eduDegree: "0",
                entryDate: "",
                officePhone: "",
                emergencyContact: "",
                emergencyPhone: "",
                roleIds: [],
                flowCode: "",
            }
            this.editStatus = true
        },
        handleEdit(row) {
            this.editType = "update"
            this.formData = {}
            this.editStatus = true
            this.getDetail(row.id, row.orgCode || this.orgCode)
        },
        getDetail(staffId, orgCode) {
            this.$get("/old/api/pc/staff/selectByStaffId", {
                staffId,
                orgCode: orgCode || this.orgCode,
            }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    const data = res.data || {}
                    this.formData = {
                        staffId: data.staffId,
                        custGlobalId: data.custGlobalId,
                        userName: data.userName,
                        phone: data.phone,
                        avatarUrl: data.avatarUrl,
                        national: data.national,
                        nativePlace: data.nativePlace,
                        address: data.address,
                        eduDegree: data.eduDegree || "0",
                        entryDate: data.entryDate,
                        officePhone: data.officePhone,
                        emergencyContact: data.emergencyContact,
                        emergencyPhone: data.emergencyPhone,
                        orgCode: data.orgCode || orgCode || this.orgCode,
                        roleIds: data.roleIds || [],
                        flowCode: data.flowCodes && data.flowCodes.length ? data.flowCodes[0] : "",
                        workStatus: data.workStatus,
                    }
                } else {
                    this.$Message.error({
                        content: res.desc || "获取详情失败",
                        background: true,
                    })
                }
            })
        },
        validateForm() {
            if (!this.formData.userName) {
                this.$Message.warning({ content: "请输入姓名", background: true })
                return false
            }
            if (!this.formData.phone) {
                this.$Message.warning({ content: "请输入手机号码", background: true })
                return false
            }
            const phoneReg = /^[1][3-9][0-9]{9}$/
            if (!phoneReg.test(this.formData.phone)) {
                this.$Message.warning({ content: "请填写正确的手机号码", background: true })
                return false
            }
            return true
        },
        buildCreatePayload() {
            const roleIds = (this.formData.roleIds || []).map(id => String(id))
            return {
                userName: this.formData.userName,
                phone: this.formData.phone,
                orgCode: this.formData.orgCode || this.orgCode,
                creatorId: this.staffId,
                userType: this.userType,
                entryDate: this.formData.entryDate || null,
                emergencyContact: this.formData.emergencyContact || "",
                emergencyPhone: this.formData.emergencyPhone || "",
                address: this.formData.address || "",
                eduDegree: this.formData.eduDegree || "0",
                national: this.formData.national || "",
                nativePlace: this.formData.nativePlace || "",
                avatarUrl: this.formData.avatarUrl || "",
                officePhone: this.formData.officePhone || "",
                flowCode: this.formData.flowCode || "",
                roleIds,
            }
        },
        buildUpdatePayload() {
            const roleIds = (this.formData.roleIds || []).map(id => String(id))
            return {
                staffId: this.formData.staffId,
                custGlobalId: this.formData.custGlobalId,
                userName: this.formData.userName,
                phone: this.formData.phone,
                orgCode: this.formData.orgCode || this.orgCode,
                entryDate: this.formData.entryDate || null,
                emergencyContact: this.formData.emergencyContact || "",
                emergencyPhone: this.formData.emergencyPhone || "",
                address: this.formData.address || "",
                eduDegree: this.formData.eduDegree || "0",
                national: this.formData.national || "",
                nativePlace: this.formData.nativePlace || "",
                avatarUrl: this.formData.avatarUrl || "",
                officePhone: this.formData.officePhone || "",
                flowCode: this.formData.flowCode || "",
                roleIds,
            }
        },
        saveEdit() {
            if (!this.validateForm()) {
                return
            }
            const isAdd = this.editType === "add"
            const url = isAdd ? "/old/api/pc/staff/createStaff" : "/old/api/pc/staff/updateStaff"
            const payload = isAdd ? this.buildCreatePayload() : this.buildUpdatePayload()
            this.$post(url, payload, { "Content-Type": "application/json" }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.$Message.success({
                        content: this.editType === "add" ? "新增成功" : "修改成功",
                        background: true,
                    })
                    this.changeEditStatus(false)
                    this.getList()
                } else {
                    this.$Message.error({
                        content: res.desc || "保存失败",
                        background: true,
                    })
                }
            })
        },
        openAuthModal(row) {
            const workStatus = String(row.orgWorkStatus || "")
            if (workStatus === "2") {
                this.$Message.warning({
                    content: "员工已离职，不能授权！",
                    background: true,
                })
                return
            }
            const url = `/#/setorgmodal?staffId=${row.id}&orgCode=${row.orgCode || this.orgCode}`
            parent.layer.open({
                type: 2,
                title: "设置权限",
                shadeClose: true,
                shade: 0.3,
                maxmin: true,
                area: ["800px", "600px"],
                content: url,
                end: () => {
                    this.getList()
                },
            })
        },
        changeWorkStatus(row, status) {
            const label = status === "1" ? "在职" : "离职"
            this.$Modal.confirm({
                title: "提示",
                content: `确定将该员工设置为${label}？`,
                onOk: () => {
                    this.$post("/old/api/pc/staff/changeOrgStaffWork", {
                        custGlobalId: row.custGlobalId,
                        orgCode: row.orgCode || this.orgCode,
                        staffId: row.id,
                        status,
                    }).then(res => {
                        if (res.code == 200 || res.code == "200") {
                            this.$Message.success({
                                content: "机构员工状态设置成功",
                                background: true,
                            })
                            this.getList()
                        } else {
                            this.$Message.error({
                                content: res.desc || "操作失败",
                                background: true,
                            })
                        }
                    })
                },
            })
        },
        handleDelete(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "正在执行注销操作，是否继续？",
                onOk: () => {
                    this.$post("/old/api/pc/staff/deleteEmployee", {
                        staffId: row.id,
                    }).then(res => {
                        if (res.code == 200 || res.code == "200") {
                            this.$Message.success({
                                content: "删除成功",
                                background: true,
                            })
                            this.getList()
                        } else {
                            this.$Message.error({
                                content: res.desc || "删除失败",
                                background: true,
                            })
                        }
                    })
                },
            })
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ #toolsbarRight {
    width: 100%;

    .search {
        width: 100%;
        text-align: right;

        .ivu-form-item {
            margin-bottom: 0;
        }
    }
}
</style>
